import { useFlags } from "flagsmith/react";

export function useAppFlags() {
  const flags = useFlags(["quiz_enabled_lms"], ["schoolId"]);
  const quizLmsEnabled = flags.quiz_enabled_lms.enabled;
  return { quizLmsEnabled };
}
